import { UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './LegalInfoButton.css';

interface ILegalInfoButtonProps {
  title?: string;
  onClick: () => void;
}

export const LegalInfoButton: React.FC<ILegalInfoButtonProps> = ({ title, onClick }) => {
  const handleKeyDown = React.useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    },
    [onClick],
  );

  return (
    <div role="button" tabIndex={0} className={styles['button']} onClick={onClick} onKeyDown={handleKeyDown}>
      <UIText2 color="text-inverted-disabled">{title || 'Классификация объекта'}</UIText2>
      <IconFunctionalInformationCircle16 color="text-inverted-disabled" />
    </div>
  );
};
